import {
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  inject,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationComponent as SdcPaginationComponent } from '@3ddv/software-division-components/backoffice/pagination';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  imports: [SdcPaginationComponent],
})
export class PaginationComponent {
  private routeService = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  protected readonly current = signal(1);
  protected readonly total = signal(0);
  protected readonly perPage = signal(1);

  protected readonly label = computed(() => {
    const shown = Math.min(
      this.perPage(),
      this.total() - (this.current() - 1) * this.perPage()
    );
    return `Showing ${Math.max(shown, 0)} of ${this.total()}`;
  });

  @Input() set totalItemsInDb(value: number) {
    this.total.set(Number(value) || 0);
  }
  @Input() set itemsPerPage(value: number) {
    this.perPage.set(Number(value) || 1);
  }
  @Input() set currentPage(value: number | string) {
    this.current.set(Number(value) || 1);
  }
  @Output() changepage = new EventEmitter<number>();

  public refresh(page, totalItemsInDb, itemsPerPage): void {
    this.totalItemsInDb = totalItemsInDb;
    this.itemsPerPage = itemsPerPage;
    this.currentPage = page;
  }

  public goto(page: number) {
    if (page === this.current()) {
      return;
    }

    const currenturl =
      '/private/' + this.activatedRoute.snapshot.routeConfig.path;
    const queryParams = { ...this.activatedRoute.snapshot.queryParams, page };
    this.routeService.navigate([currenturl], { queryParams });
    this.current.set(page);
    this.changepage.emit(page);
  }
}
